import { Response } from '@custom-types/Response';
import apiFn from '@services/api-service';

export type Company = {
  id: string;
  name: string;
  logoImage?: {
    id: string;
    fullSizeUrl: string;
    standardSizeUrl: string;
    thumbnailUrl: string;
  };
};
interface Params {
  page: number;
  eventId: string;
  search?: string;
}

const api = (eventId: string) => apiFn(`/api/uapi/events/${eventId}/companies`);
const onsiteApi = () => apiFn('/api/uapi/onsite-app/companies');

export const get = (eventId: string, id: string) =>
  api(eventId)
    .get(id)
    .then((response: Response<Company>) => response.data.data);

export const list = (page: number, eventId: string, searchValue = '') => {
  const params: Params = {
    page,
    eventId,
  };

  if (searchValue) {
    params.search = searchValue;
  }

  return onsiteApi()
    .get('', { params })
    .then(({ data: { data, meta } }: Response<Company[]>) => ({
      data,
      meta,
    }));
};
